import { ADDRESS_TYPE } from '~~/types/AddressType';
import type { AddressType } from '~~/types/AddressType';

// Longest value a single address line accepts
export const ADDRESS_FIELD_MAX_LENGTH = 36;

const DEFAULT_ADDRESS_FIELD_MAX_LENGTHS = {
  company: 50,
  streetName: ADDRESS_FIELD_MAX_LENGTH,
  additionalAddressInfo: ADDRESS_FIELD_MAX_LENGTH,
  city: ADDRESS_FIELD_MAX_LENGTH,
};

type LengthLimitedAddressField = keyof typeof DEFAULT_ADDRESS_FIELD_MAX_LENGTHS;

/**
 * A shipping address has to fit what the carriers accept, which is what the defaults are for. A
 * billing address only ever ends up on the invoice, so it can hold the longer company names and
 * delivery notes that customers - business ones above all - actually have.
 */
export const ADDRESS_FIELD_MAX_LENGTHS: Record<AddressType, Record<LengthLimitedAddressField, number>> = {
  [ADDRESS_TYPE.Shipping]: DEFAULT_ADDRESS_FIELD_MAX_LENGTHS,
  [ADDRESS_TYPE.Billing]: {
    ...DEFAULT_ADDRESS_FIELD_MAX_LENGTHS,
    company: 100,
    additionalAddressInfo: 255,
  },
};

export const ADDRESS_FIELDS = {
  [ADDRESS_TYPE.Shipping]: {
    email: 'emailShipping',
    firstName: 'firstNameShipping',
    lastName: 'lastNameShipping',
    clientType: 'clientTypeShipping',
    streetName: 'streetNameShipping',
    additionalAddressInfo: 'additionalAddressInfoShipping',
    vatNumber: 'vatNumberShipping',
    city: 'cityShipping',
    company: 'companyShipping',
    country: 'countryShipping',
    phone: 'phoneShipping',
    postalCode: 'postalCodeShipping',
  },
  [ADDRESS_TYPE.Billing]: {
    email: 'emailBilling',
    firstName: 'firstNameBilling',
    lastName: 'lastNameBilling',
    clientType: 'clientTypeBilling',
    streetName: 'streetNameBilling',
    additionalAddressInfo: 'additionalAddressInfoBilling',
    vatNumber: 'VatNumberBilling',
    city: 'cityBilling',
    company: 'companyBilling',
    country: 'countryBilling',
    phone: 'phoneBilling',
    postalCode: 'postalCodeBilling',
  },
};
